export default "__VITE_ASSET__ClD624Ae__"